import React from "react";
import { ChevronRight } from "lucide-react";

interface OverviewModalButtonProps {
  label: string;
  count: number;
  onClick: () => void;
}

const OverviewModalButton: React.FC<
  OverviewModalButtonProps
> = ({
  label,
  count,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="
        flex
        items-center
        gap-2
        rounded-[8px]
        border
        border-[#E5E5E5]
        bg-white
        px-3
        py-[6px]
        shadow-[0_1px_2px_rgba(0,0,0,0.05)]
        transition-colors
        hover:bg-[#FAFAFA]
      "
    >
      <span
        className="
          text-sm
          font-medium
          leading-none
          text-[#0A0A0A]
        "
      >
        {label}
      </span>

      <div
        className="
          flex
          min-w-[20px]
          items-center
          justify-center
          rounded-[8px]
          bg-[#EBEFFE]
          px-2
          py-[2px]
        "
      >
        <span
          className="
            text-xs
            font-semibold
            text-[#3551F3]
          "
        >
          {count}
        </span>
      </div>

      <ChevronRight
        size={16}
        className="text-[#737373]"
      />
    </button>
  );
};

export default OverviewModalButton;